import { type Alias } from '#shared/api/schema';
import { type ConstructorLeftBarTab } from './slices/types';

// Дублируем константы отсюда:
// https://a.yandex-team.ru/arcadia/adv/frontend/adv/frontend/packages/yastore-kitqat/src/constants/entities/constructor.ts
// Если добавляем в одно место, добавляем и в другое
export const CONSTRUCTOR_HEADER_ID = 'YandexKit.Header';
export const CONSTRUCTOR_HEADER_MAIN_MODULE_ID = 'main';
export const CONSTRUCTOR_HEADER_ADDITIONAL_MODULE_ID = 'additional';
export const CONSTRUCTOR_FOOTER_ID = 'YandexKit.Footer';
export const CONSTRUCTOR_PRODUCT_DETAILS_ID = 'YandexKit.ProductDetails';
export const CONSTRUCTOR_PRODUCTS_LISTING_ID = 'YandexKit.ProductsListing';
export const CONSTRUCTOR_COLLECTIONS_LISTING_ID = 'YandexKit.CollectionsListing';
export const CONSTRUCTOR_ACCOUNT_FAVOURITE_PRODUCTS_ID = 'YandexKit.FavouriteProducts';
export const CONSTRUCTOR_SHOPPING_CART_ID = 'YandexKit.ShoppingCart';
export const CONSTRUCTOR_ANNOUNCEMENT_BAR_ID = 'YandexKit.AnnouncementBar';
export const CONSTRUCTOR_DISCOUNT_LADDER_ID = 'YandexKit.DiscountLadder';
export const CONSTRUCTOR_SLIDESHOW_ID = 'YandexKit.BannersCarousel';
export const CONSTRUCTOR_FEATURED_BLOGS_ID = 'YandexKit.FeaturedBlogs';
export const CONSTRUCTOR_FEATURED_COLLECTIONS_ID = 'YandexKit.FeaturedCollections';
export const CONSTRUCTOR_FEATURED_PRODUCTS_ID = 'YandexKit.FeaturedProducts';
export const CONSTRUCTOR_IMAGE_WITH_TEXT_ID = 'YandexKit.ImageWithText';
export const CONSTRUCTOR_RICH_TEXT_ID = 'YandexKit.RichText';
export const CONSTRUCTOR_MYSTIQUE_ID = 'YandexKit.Mystique';
export const CONSTRUCTOR_COLLECTION_LISTING_ID = 'YandexKit.CollectionListing';
export const CONSTRUCTOR_BLOG_LISTING_ID = 'YandexKit.BlogListing';
export const CONSTRUCTOR_BLOG_ID = 'YandexKit.Blog';

export const CONSTRUCTOR_PREVIEW_MODE_DEFAULT_VALUE = 'desktop';

export const CONSTRUCTOR_MINIMUM_SECTION_SEQUENCE = 2;

export const CONSTRUCTOR_LEFT_BAR_TAB_SEARCH_PARAM_KEY = 'tab';

export const CONSTRUCTOR_LEFT_BAR_TAB_PAGE = 'pages';

// При подстановке этого ключа в параметр section в правом сайдбаре откроются настройки страницы
export const CONSTRUCTOR_PAGE_RIGHT_BAR_KEY = 'page';

export const CONSTRUCTOR_LEFT_BAR_TABS: ConstructorLeftBarTab[] = ['theme', CONSTRUCTOR_LEFT_BAR_TAB_PAGE, 'sections'];

export const CONSTRUCTOR_LEFT_TAB_DEFAULT: ConstructorLeftBarTab = 'theme';

export const CONSTRUCTOR_MAIN_PAGE_ALIAS = 'main';
export const CONSTRUCTOR_PRODUCT_CARD_ALIAS = 'productCard';
export const CONSTRUCTOR_PRODUCT_REVIEWS_ALIAS = 'productReviews';
export const CONSTRUCTOR_CATALOG_ALIAS = 'catalog';
export const CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS = 'categoryAndCollection';
export const CONSTRUCTOR_SEARCH_ALIAS = 'search';
export const CONSTRUCTOR_CART_ALIAS = 'cart';
export const CONSTRUCTOR_CART_PREVIEW_ALIAS = 'cartPreview';
export const CONSTRUCTOR_CART_PAGES = [CONSTRUCTOR_CART_ALIAS, CONSTRUCTOR_CART_PREVIEW_ALIAS];
export const CONSTRUCTOR_BLOG_ALIAS = 'blog';
export const CONSTRUCTOR_BLOG_ENTRY_ALIAS = 'blogEntry';
export const CONSTRUCTOR_FAVOURITE_PRODUCTS_ALIAS = 'favouriteProducts';
export const CONSTRUCTOR_404_PAGE_ALIAS = '404';
export const CONSTRUCTOR_PRIVACY_ALIAS = 'privacy';
export const CONSTRUCTOR_PAYMENT_ALIAS = 'payment';
export const CONSTRUCTOR_DELIVERY_ALIAS = 'delivery';
export const CONSTRUCTOR_RETURN_ALIAS = 'return';
export const CONSTRUCTOR_DETAILS_ALIAS = 'details';
export const CONSTRUCTOR_OFFER_ALIAS = 'oferta';
export const CONSTRUCTOR_LEGAL_PAGES = [
    CONSTRUCTOR_PRIVACY_ALIAS,
    CONSTRUCTOR_PAYMENT_ALIAS,
    CONSTRUCTOR_DELIVERY_ALIAS,
    CONSTRUCTOR_RETURN_ALIAS,
    CONSTRUCTOR_DETAILS_ALIAS,
    CONSTRUCTOR_OFFER_ALIAS,
];
export const CONSTRUCTOR_ADDONS_ALIAS = 'addons';

export const CONSTRUCTOR_GIFT_CARD_ALIAS = 'giftCard';

export const CONSTRUCTOR_GIFT_CARD_QUESTIONS_ALIAS = 'giftCardQuestions';

export const CONSTRUCTOR_GIFT_PAGES = [CONSTRUCTOR_GIFT_CARD_ALIAS, CONSTRUCTOR_GIFT_CARD_QUESTIONS_ALIAS];

export const CONSTRUCTOR_LOYALTY_OFFER_ALIAS = 'loyaltyOffer';
export const CONSTRUCTOR_LOYALTY_LANDING_ALIAS = 'loyaltyLanding';
export const CONSTRUCTOR_LOYALTY_PAGES = [CONSTRUCTOR_LOYALTY_OFFER_ALIAS, CONSTRUCTOR_LOYALTY_LANDING_ALIAS];

export const CONSTRUCTOR_ACCOUNT_ORDERS_ALIAS = 'accountOrders';
export const CONSTRUCTOR_ACCOUNT_ORDER_DETAILS_ALIAS = 'accountOrderDetails';
export const CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS = 'accountRefunds';
export const CONSTRUCTOR_ACCOUNT_PROFILE_ALIAS = 'accountProfile';
export const CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS = 'accountLoyalty';
export const CONSTRUCTOR_ACCOUNT_NEWSLETTERS_ALIAS = 'accountNewsletters';
export const CONSTRUCTOR_ACCOUNT_PAGES = [
    CONSTRUCTOR_ACCOUNT_PROFILE_ALIAS,
    CONSTRUCTOR_ACCOUNT_ORDERS_ALIAS,
    CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS,
    CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS,
    CONSTRUCTOR_ACCOUNT_NEWSLETTERS_ALIAS,
    CONSTRUCTOR_ACCOUNT_ORDER_DETAILS_ALIAS,
];

export const CONSTRUCTOR_PRODUCTS_BUNDLE_ALIAS = 'productBundle';
export const CONSTRUCTOR_DISCOUNT_LADDER_ALIAS = 'discountLadder';

export const CONSTRUCTOR_SUBSCRIPTION_ALIAS = 'subscription';
export const CONSTRUCTOR_UNSUBSCRIBE_ALIAS = 'unsubscribe';

export const CONSTRUCTOR_RENAME_PAGES = [...CONSTRUCTOR_LEGAL_PAGES, CONSTRUCTOR_BLOG_ALIAS];

export const CONSTRUCTOR_META_PAGES = [CONSTRUCTOR_MAIN_PAGE_ALIAS, CONSTRUCTOR_BLOG_ALIAS, CONSTRUCTOR_404_PAGE_ALIAS];
export const CONSTRUCTOR_META_PAGES_EXPLANATION = [...CONSTRUCTOR_ACCOUNT_PAGES];

export const CONSTRUCTOR_ALIASES_WITH_TEMPLATES: Alias[] = [
    CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS,
    CONSTRUCTOR_PRODUCT_CARD_ALIAS,
];

export const CONSTRUCTOR_ALIASES_WITH_TEMPLATES_TITLES: Partial<Record<NonNullable<Alias>, string>> = {
    [CONSTRUCTOR_CATEGORY_AND_COLLECTION_ALIAS]: 'Категория и коллекция',
    [CONSTRUCTOR_PRODUCT_CARD_ALIAS]: 'Товар',
};

export const getConstructorAliasWithTemplatesTitle = (page: { alias?: Alias; title: string }) =>
    (page.alias && CONSTRUCTOR_ALIASES_WITH_TEMPLATES_TITLES[page.alias]) || page.title;

export const CONSTRUCTOR_ALIASES_SOON_WITH_TEMPLATES: Alias[] = [CONSTRUCTOR_BLOG_ENTRY_ALIAS];

export const CONSTRUCTOR_ALLOWED_TO_HIDE_PAGES: Alias[] = [CONSTRUCTOR_BLOG_ALIAS, CONSTRUCTOR_BLOG_ENTRY_ALIAS];
export const CONSTRUCTOR_HIDE_WITH_DESCRIPTION_PAGES: Alias[] = [
    CONSTRUCTOR_FAVOURITE_PRODUCTS_ALIAS,
    CONSTRUCTOR_GIFT_CARD_ALIAS,
    CONSTRUCTOR_GIFT_CARD_QUESTIONS_ALIAS,
    CONSTRUCTOR_LOYALTY_OFFER_ALIAS,
    CONSTRUCTOR_LOYALTY_LANDING_ALIAS,
    CONSTRUCTOR_ACCOUNT_LOYALTY_ALIAS,
    CONSTRUCTOR_PRODUCTS_BUNDLE_ALIAS,
    CONSTRUCTOR_SUBSCRIPTION_ALIAS,
];

// Дублируем в yastore-kitqat/src/constants/entities/constructor.ts → constructorConstants.limits
export const CONSTRUCTOR_DEFAULT_MAX_PAGES = 100;
export const CONSTRUCTOR_DEFAULT_MAX_SECTIONS = 50;
export const CONSTRUCTOR_DEFAULT_MAX_MODULES = 50;
